/**
 * Module to generate the sharing functionality.
 * This module consists out of sub functions to share on facebook, twitter, linkedin and email
 */

var winHeight = 450,
    winWidth = 520,
    shareData = {
        winTop: (window.innerHeight / 2) - (winHeight / 2),
        winLeft: (window.innerWidth / 2) - (winHeight / 2),
        url: window.location.href,
        title: encodeURI($(document).find('title').text()),
        desc: $('meta[name="description"]').attr('content')
    };

function facebookShare(data) {
    $('.js-share-facebook').on('click', function (e) {
        e.preventDefault();
        window.open('http://www.facebook.com/sharer.php?u=' + data.url, 'sharer', 'top=' + data.winTop + ',left=' + data.winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    });
}

function twitterShare(data) {
    $('.js-share-twitter').on('click', function (e) {
        e.preventDefault();
        window.open('https://twitter.com/share?text=' + data.title + '&url=' + data.url, 'twitterwindow', 'top=' + data.winTop + ',left=' + data.winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    });
}

function shareLinkedIn(data) {
    $('.js-share-linkedin').on('click', function (e) {
        e.preventDefault();
        window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + data.url + '&title=' + data.title + '&description=' + data.desc, 'sharer', 'top=' + data.winTop + ',left=' + data.winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    });

}

function shareEmail(data) {
    $('.js-share-email').on('click', function (e) {
        var body = $(this).data('email-body');
        e.preventDefault();
        window.location.href = 'mailto:?subject=' + data.title + '&body=' + body + ' ' + data.url;
    });

}


function shareWhatsapp(data) {
    $('.js-share-whatsapp').on('click', function (e) {
        e.preventDefault();
        window.location.href = 'whatsapp://send?text='+ data.title +': ' + data.url;
    });
}


function init() {
    facebookShare(shareData);
    twitterShare(shareData);
    shareLinkedIn(shareData);
    shareEmail(shareData);
    shareWhatsapp(shareData);
}

$(init); // init share buttons on detailpages